import { defineMessages } from 'react-intl';

export default defineMessages({
  oldLabel: {
    id: 'userControl.form.label.oldPassword',
    defaultMessage: 'Kata Sandi Lama Anda',
  },
  oldPlaceholder: {
    id: 'userControl.form.placeholder.oldPassword',
    defaultMessage: 'Masukkan kata sandi lama anda',
  },
  newLabel: {
    id: 'userControl.form.label.newPassword',
    defaultMessage: 'Kata Sandi Baru',
  },
  newPlaceholder: {
    id: 'userControl.form.placeholder.newPassword',
    defaultMessage: 'Masukkan kata sandi baru anda',
  },
  required: {
    id: 'userControl.form.required',
    defaultMessage: 'Password wajib di isi',
  },
  validation: {
    id: 'userControl.form.validation',
    defaultMessage:
      'Kata sandi setidaknya terdiri dari satu angka, satu huruf kecil, satu huruf besar dan 8-16 karakter',
  },
  submit: {
    id: 'userControl.form.submit',
    defaultMessage: 'Simpan',
  },
});
